import * as React from 'react';
import { GridCell } from "@progress/kendo-react-grid";
import { Link } from 'react-router-dom';
import * as moment from 'moment';

export default class DocumentTitleCell extends GridCell {
    render() {
        if (!this.props.field) return null;

        return (
            <td><Link to={`/document/${this.props.dataItem.DocumentID}`}>{this.props.dataItem.Title || "No Title"}</Link></td>
        );
    }
}

export class DocumentCreatedCell extends GridCell {
    render() {
        if (!this.props.field) return null;

        return (
            <td><span>{moment.utc(this.props.dataItem.CreatedDate).local().format('MM/DD/YYYY hh:mm a')}</span></td>
        );
    }
}
